import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.from-entries.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.trim.js";
import { useLocalization } from '~/composables/_next/useLocalization';
export default defineNuxtPlugin(function () {
  var _useNuxt2App = useNuxt2App(),
    axeptioClientID = _useNuxt2App.$config.axeptioClientID;
  var _useLocalization = useLocalization(),
    locale = _useLocalization.locale;
  if (process.client) {
    /**
     * Returns full consent context for analytics (to inject into Segment)
     * TEMPORARY: This is a workaround,check the real implementation on NUXT 3 here:
     * https://github.com/aroma-zone/replatforming/pull/8334
     */
    var getConsentContext = function getConsentContext() {
      var _vendorConsentCookie$, _vendorConsentCookie$2;
      var vendorConsentCookie = useCookie('axeptio_authorized_vendors', {
        readonly: true
      });
      var authorizedVendors = (_vendorConsentCookie$ = (_vendorConsentCookie$2 = vendorConsentCookie.value) === null || _vendorConsentCookie$2 === void 0 ? void 0 : _vendorConsentCookie$2.split(',')) !== null && _vendorConsentCookie$ !== void 0 ? _vendorConsentCookie$ : [];
      var categoryPreferences = Object.fromEntries(authorizedVendors.map(function (vendor) {
        return vendor.trim();
      }).filter(function (vendor) {
        return vendor.length > 0;
      }).map(function (vendor) {
        return [vendor.toLowerCase(), true];
      }));
      return {
        context: {
          consent: {
            categoryPreferences: categoryPreferences
          }
        }
      };
    };
    window.axeptioSettings = {
      clientId: axeptioClientID,
      cookiesVersion: "az-main-".concat(locale),
      googleConsentMode: {
        default: {
          analytics_storage: 'denied',
          ad_storage: 'denied',
          ad_user_data: 'denied',
          ad_personalization: 'denied',
          wait_for_update: 500
        }
      }
    };
    (function (d, s) {
      var t = d.getElementsByTagName(s)[0];
      var e = d.createElement(s);
      e.async = true;
      e.src = 'https://static.axept.io/sdk.js';
      t.parentNode.insertBefore(e, t);
    })(document, 'script');
    window._axcb = window._axcb || [];
    window._axcb.push(function (sdk) {
      sdk.on('cookies:complete', function () {
        var _window$analytics;
        var consentContext = getConsentContext();
        if ((_window$analytics = window.analytics) !== null && _window$analytics !== void 0 && _window$analytics.track) {
          window.analytics.track('Consent Preferences Updated', consentContext);
        }
      });
    });
  }
});